import React, { Component } from 'react';
import { connect } from 'react-redux';
import { getTranslate, getActiveLanguage } from 'react-localize-redux';
import { withRouter } from 'react-router-dom';

import InvoiceItems from './InvoiceItems';
import InvoicesService from '../../services/InvoicesService';
import Pagination from '../Pagination/Pagination';


class Invoices extends Component {
  constructor() {
    super();
    this.state = { totalPages: '' };
  }

  componentDidMount() {
    this.getInvoicesToDispley()
  }
  componentDidUpdate(prevProps) {
   if (this.props.location !== prevProps.location) {
     this.onRouteChanged();
   }
 }
 onRouteChanged() {
   const {rest, setInvoices} = this.props;
   InvoicesService.getInvoices(rest.computedMatch.params.page)
     .then((res) => {
       const totalPages = res.body.meta["total-pages"];
       setInvoices(res.body.data.invoices)
       this.setState({
         totalPages: totalPages,
       })
     }).catch(error => {
     console.log(error);
     });
  }
  getInvoicesToDispley(){
    const {rest, setInvoices, } = this.props;
    InvoicesService.getInvoices(rest.computedMatch.params.page)
      .then((res) => {
        const totalPages = res.body.meta["total-pages"];
        setInvoices(res.body.data.invoices)
        this.setState({
          totalPages: totalPages,
        })
      }).catch(error => {
      console.log(error);
      });
  }

  render() {
    const { translate, rest } = this.props;
    return (
      <div id="bills">
        <h1 className="title">{translate('invoices')}</h1>
        <div className="row row-head" >
          <div className="col-1 hidden-md-down">
          </div>
          <div className="col-md-3 col-lg-2 hidden-sm-down">{translate('date')}</div>
          <div className="col-md-3 push-md-4 col-lg-2 push-lg-4  hidden-sm-down">{`${translate('total')}`}<br/>{`(${translate('includes VAT')})`}</div>
          <div className="col-md-4 pull-md-3 col-lg-4 pull-lg-2 hidden-sm-down">{translate('invoice-number')}</div>
          <div className="col-md-2 col-lg-3 hidden-sm-down">
            <a className="d-inline-block"  target="_blank"  href="https://www.annatel.co.il/client.php/client/account/paiementInformations">
              {translate('pay-all-invoices')}</a>
          </div>
        </div>
      <InvoiceItems/>
      {Pagination(this.state.totalPages,rest.computedMatch.params.page)}
      </div>
    )
  }
};

const viewMapStateToProps = (state) => {
  return {
    translate: getTranslate(state.locale),
    currentLanguage: getActiveLanguage(state.locale).code,
    payment: state.User.paymentMethod,
    invoices: Invoices,
  }
}

const viewMapDispatchToProps = (dispatch) => {
  return {
    setInvoices: (invoices) => {
      dispatch(
        {
          type: 'SET_INVOICES',
          invoices: invoices,
        },
      );
    },
  }
}

Invoices = connect(
  viewMapStateToProps,
  viewMapDispatchToProps,
)(Invoices);


export default withRouter(Invoices);



// WEBPACK FOOTER //
// ./src/components/Invoices/Invoices.js